'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _clientLogger = require('./clientLogger');

var _clientLogger2 = _interopRequireDefault(_clientLogger);

var _serverLogger = require('./serverLogger');

var _serverLogger2 = _interopRequireDefault(_serverLogger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLogger = global.__SERVER__ ? _serverLogger2.default : _clientLogger2.default;

exports.default = createLogger;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/middleware/logger/index.js
// module id = JcK0
// module chunks = 46